define('lq/events/actions/executeMethod',[
    'underscore',
    'lq/events/actions/eventAction'
], function (_, EventAction) {
    'use strict';

    function ExecuteMethod(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ExecuteMethod, EventAction);

    ExecuteMethod.typeName = 'ExecuteMethod';

    ExecuteMethod.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExecuteMethod.prototype.execute = function (continuation) {
        var methodName = 'licquidMethod_' + this.eventData.method;
        var drop = this.piping.dropFactory.findDropByName(this.eventData.drop);

        if (!drop)
            throw 'Cannot find drop : "' + this.eventData.drop + '".';

        if (!drop[methodName])
            throw 'Cannot call method : "' + this.eventData.method + '" on drop "' + this.eventData.drop + '".';

        var self = this;
        var args = _.object(_.map(_.keys(this.eventData.argumentMappings), function (argumentName) {
            return [argumentName, self.piping.parameters.getValue(self.eventData.argumentMappings[argumentName])];
        }));
        drop[methodName](args);

        continuation();
    };

    return ExecuteMethod;
});
